import React, {SyntheticEvent, useState} from "react";
import {RecentOrders} from "../../../components/RecentOrders";
import {Tabs, Tab, Box} from "@mui/material";
import styled from "styled-components";
import {DeliveriesTable} from "./DeliveriesTable";
import AssignDeliveryModal from "../../../components/AssignDelivery";
import {AssignedDeliveriesTable} from "./AssignedDeliveries";
import {UnassignedDeliveriesTable} from "./UnassignedDelivery";
import AppLayout from "../../../layouts/AdminLayout";
import {ManifestTable} from "./ManifestTable";
import {useNavigate} from "react-router-dom";
import {FailedDeliveriesTable} from "./FailedDeliveries";
import {useRoles} from "../../../hooks/useRoles";

export default function Deliveries() {
  const {scope} = useRoles();
  const [value, setValue] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDeliveries, setSelectedDeliveries] = useState<any[]>([]);
  const navigate = useNavigate();

  const toggleOpen = () => setIsOpen(!isOpen);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    navigate(`?page=1`);
    setValue(newValue);
  };

  const tabs = [
    {
      label: "All Deliveries",
      value: "all",
      component: <DeliveriesTable />,
    },
    {
      label: "Unassigned Deliveries",
      value: "unassigned",
      component: (
        <UnassignedDeliveriesTable
          selectedDeliveries={selectedDeliveries}
          setSelectedDeliveries={setSelectedDeliveries}
        />
      ),
    },
    {
      label: "Failed Deliveries",
      value: "failed",
      component: (
        <FailedDeliveriesTable
          selectedDeliveries={selectedDeliveries}
          setSelectedDeliveries={setSelectedDeliveries}
        />
      ),
    },
    {
      label: "Assigned Deliveries",
      value: "assigned",
      component: <AssignedDeliveriesTable />,
    },
    {
      label: "Manifests",
      value: "manifest",
      component: <ManifestTable />,
    },
  ];

  return (
    <AppLayout>
      <div className="flex items-center justify-between !py-10 !px-9">
        <div>
          <h3 className="!text-[28px] !font-bold !text-[#272835]">
            Delivery Management
          </h3>
          <p className="!text-sm !text-[#818898]">
            View and track all your deliveries details below
          </p>
        </div>
        {value === 1 && scope === "write" && (
          <button
            className={`!text-sm !font-bold !text-white !h-12 !px-4 ${
              selectedDeliveries.length < 1 ? "bg-[#f27f1f]/20" : "bg-[#f27f1f]"
            }  rounded-[10px]`}
            disabled={selectedDeliveries.length < 1}
            onClick={toggleOpen}
          >
            Assign Delivery({selectedDeliveries.length})
          </button>
        )}
      </div>
      <AssignDeliveryModal
        closeModal={() => setIsOpen(false)}
        isOpen={isOpen}
        selectedDeliveries={selectedDeliveries}
        setSelectedDeliveries={setSelectedDeliveries}
      />
      <Box
        sx={{
          height: "100%",
          width: "92%",
          margin: "24px auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{borderBottom: 1, borderColor: "#E2E2E2"}}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#4B5563",
                height: 2,
              },
            }}
          >
            {tabs.map(({label}, index) => (
              <Tab
                key={index}
                label={label}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  textTransform: "none",
                  color: value === index ? "#4B5563" : "#9CA3AF", // gray-700 and gray-400
                  minWidth: 0,
                  padding: "0 16px 12px",
                  marginRight: "16px",
                  "&.Mui-selected": {
                    color: "#4B5563",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{mt: 3, flex: 1}}>
          {tabs.map(({component}, index) => (
            <div
              key={index}
              role="tabpanel"
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
            >
              {value === index && component}
            </div>
          ))}
        </Box>
      </Box>
    </AppLayout>
  );
}
const Body = styled.main`
  display: flex;
`;
const Wrapper = styled.main`
  width: 85vw;
  overflow-y: scroll;
  margin-left: 15vw;
  background-color: #fafafa;
  margin-bottom: 10vh;
  @media (max-width: 425px) {
  }
`;
